export default __webpack_public_path__ + "d228367.png";